// extracted by mini-css-extract-plugin
module.exports = {"centeredContent":"_2Fm7DoMBoTExL1MBneUHkl","close":"B-xvoEhWNjQYXlBNGRd0w"};